
import React from "react";

import { BellElectric, Folder, ImagePlay, ListCheck, ListChecks, Play } from "lucide-react"
const PlayerPageCardSubCourseLoading =({coursePageObject})=>{

 
    return(<>
    
      <div style={{padding:"10px"}}>
       
    
 <div 
             style={{border:"3px solid #f1f1f1",
                position:"relative",marginBottom:"20px",marginTop:"0px",overflow:"hidden",
                boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)",
   borderTopLeftRadius:`${coursePageObject?.subCourseCard?.borderRadius?.topLeft?.value}${coursePageObject?.subCourseCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subCourseCard?.borderRadius?.topRight?.value}${coursePageObject?.subCourseCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subCourseCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.subCourseCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subCourseCard?.borderRadius?.bottomRight?.value}${coursePageObject?.subCourseCard?.borderRadius?.bottomRight?.resolution}`,
}} 
          
             
            >
<div  className="" style={{position:"absolute",top:"90px",left:"40%",width:"90px",
                      zIndex:"99", textAlign:"center" ,cursor:"pointer"
             ,background:`#ffffff`,
             borderTopLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.topLeft?.value}${coursePageObject?.playerButton?.borderRadius?.topLeft?.resolution}`,
                         borderTopRightRadius:`${coursePageObject?.playerButton?.borderRadius?.topRight?.value}${coursePageObject?.playerButton?.borderRadius?.topRight?.resolution}`,
                         borderBottomLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.resolution}`,
                         borderBottomRightRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomRight?.value}${coursePageObject?.playerButton?.borderRadius?.bottomRight?.resolution}`,
                   
                   }}>
                     <Play strokeWidth={3}  size={35}style={{margin:"13px"}}  color={"#f1f1f1"}/>
                    </div>
       
    <div className="text-linetw" style={{width:"92%",height:"170px"}}></div>
       
<div className="coursePageTitleFont text-linetw" style={{padding:"5px",fontSize:"22px",height:"25px"}}></div>
<div  className="text-linetw" style={{padding:"5px",fontSize:"12px",height:"25px"}} ></div>
  <div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",flexWrap:"wrap",position:"relative",gap:"10px"}}> 
                     <div className="text-linetw" style={{padding:"5px",height:"25px",width:"80px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",}}> 
                         <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px"}}> 
                           </div>
                           </div>
 <div className="text-linetw" style={{padding:"5px",height:"25px",width:"80px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",}}> 
                         <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px"}}> 
                           </div>
                           </div>
 <div className="text-linetw" style={{padding:"5px",height:"25px",width:"80px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",}}> 
                         <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px"}}> 
                           </div>
                           </div>
 <div className="text-linetw" style={{padding:"5px",height:"25px",width:"80px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",}}> 
                         <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px"}}> 
                           </div>
                           </div>

                   </div>
           </div>

        
        <div  align="center" className="" style={{paddingBottom:"10px",background:"",marginTop:"5px", display: "flex",
        justifyContent:"space-between"}}> 
<div  className="text-linetw" style={{height:"25px",width:"120px",
                   fontSize:"13px",  margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer",
 borderTopLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.resolution}`,
 }}></div><div  className="text-linetw" style={{height:"25px",width:"90px",
                   fontSize:"13px", margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer",
 borderTopLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.resolution}`,
 }}></div>
</div>
</div> </div>

    </>)
}

export default PlayerPageCardSubCourseLoading;
